import React, { useState, useRef, useEffect } from 'react';
import { CardNumberElement, CardExpiryElement, CardCvcElement, useStripe, useElements } from '@stripe/react-stripe-js';
import './stripepaymentform.css';
import visa from '../../imagesHome/visa.png';
import mastercard from '../../imagesHome/mastercard.png';



const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: '#32325d',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '16px',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#fa755a',
    },
  },
};

const StripePaymentForm = ({ amount }) => {
  const stripe = useStripe();
  const elements = useElements();


  const [processing, setProcessing] = useState(false);
  const [success, setSuccess] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(amount === 55000 ? 'anual' : 'lunar');

  // Custom dropdown logic
  const dropdownRef = useRef(null);
  const planOptions = [
    { value: 'anual', label: 'Premium anual' },
    { value: 'lunar', label: 'Premium lunar' }
  ];
  const handleDropdownSelect = (val) => {
    setSelectedPlan(val);
    setDropdownOpen(false);
  };
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  let planText = selectedPlan === 'anual' ? 'Premium Anual' : 'Premium Lunar';
  let planDesc = selectedPlan === 'anual'
    ? 'Acces complet • Certificat • Suport dedicat'
    : 'Acces complet • Exercitii • Aplicatii';
  let planPrice = selectedPlan === 'anual' ? '550 lei' : '70 lei';

  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

    setTimeout(() => {
      setProcessing(false);
      setSuccess(true);
    }, 1500);
  };

  return (
    <div className="checkout-page">
      <div className="checkout-layout">
        {/* LEFT */}
        <form className="checkout-card sololearn-card" onSubmit={handleSubmit}>
          <div className="sololearn-card-header" style={{justifyContent: 'space-between', alignItems: 'center'}}>
            <span style={{fontWeight: 700, fontSize: '18px'}}>Plata cu cardul</span>
            <span className="sololearn-card-icons" style={{display: 'flex', alignItems: 'center', gap: '8px'}}>
              <img src={visa} alt="Visa" style={{height: 28, width: 48, objectFit: 'contain', display: 'block'}} />
              <img src={mastercard} alt="Mastercard" style={{height: 28, width: 48, objectFit: 'contain', display: 'block'}} />
            </span>
          </div>
          <div className="sololearn-form-row">
            <div className="sololearn-form-field sololearn-form-field-full card-number-full-width">
              <label>Numarul cardului *</label>
              <div className="card-element-wrapper">
                <CardNumberElement options={CARD_ELEMENT_OPTIONS} />
              </div>
            </div>
          </div>
          <div className="expiration-cvv-row">
            <div className="sololearn-form-field expiration-half">
              <label>Data expirare *</label>
              <div className="card-element-wrapper">
                <CardExpiryElement options={CARD_ELEMENT_OPTIONS} />
              </div>
            </div>
            <div className="sololearn-form-field expiration-half">
              <label>Codul CVV2/CVC2 *</label>
              <div className="card-element-wrapper">
                <CardCvcElement options={CARD_ELEMENT_OPTIONS} />
              </div>
            </div>
          </div>
          <div className="sololearn-form-row card-email-vertical">
            <div className="sololearn-form-field">
              <label>Titular card *</label>
              <input
                type="text"
                placeholder="Numele complet de pe card"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
              />
            </div>
            <div className="sololearn-form-field">
              <label>Email *</label>
              <input
                type="email"
                placeholder="adresa@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <span className="email-hint">Vei primi acces instant dupa plata</span>
            </div>
          </div>
          {/* Secure row moved below */}
          {success && (
            <div className="success-msg">
              Plata efectuata cu succes (simulare)
            </div>
          )}


            <div className="sololearn-pay-bottom-bar">
          <button
            className="sololearn-pay-btn"
            disabled={processing || !stripe}
            onClick={handleSubmit}
          >
            {processing ? 'Se proceseaza...' : 'Platesc in siguranta'}
          </button>
          <div className="sololearn-secure-row">
            <span className="sololearn-secure-badge">🔒 Plati securizate garantat</span>
          </div>
          <div className="sololearn-powered">
            Procesat prin Stripe
          </div>
          <div className="sololearn-summary-note">
            Vei fi taxat automat la finalul perioadei de proba.<br />
            Poti anula oricand inainte din Setari.
          </div>
        </div>
        
        </form>

        {/* RIGHT */}
        <div className="checkout-summary sololearn-summary">
          {/* Invoice info inside summary card */}
          <div className="sololearn-summary-header" style={{display: 'block', marginBottom: 18}}>
            <label className="sololearn-summary-title" style={{display: 'block', marginBottom: 6, fontWeight: 700, fontSize: 18}}>Planul selectat</label>
            <div className="custom-dropdown" ref={dropdownRef} style={{width: '100%'}}>
              <button
                type="button"
                className="custom-dropdown-btn"
                onClick={() => setDropdownOpen((open) => !open)}
                aria-haspopup="listbox"
                aria-expanded={dropdownOpen}
                style={{width: '100%'}}
              >
                {planOptions.find(opt => opt.value === selectedPlan)?.label}
                <span className="custom-dropdown-arrow" style={{marginLeft: 8}}></span>
              </button>
              {dropdownOpen && (
                <ul className="custom-dropdown-list" role="listbox">
                  {planOptions.map(opt => (
                    <li
                      key={opt.value}
                      className={`custom-dropdown-option${selectedPlan === opt.value ? ' selected' : ''}`}
                      role="option"
                      aria-selected={selectedPlan === opt.value}
                      onClick={() => handleDropdownSelect(opt.value)}
                    >
                      {opt.label}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
          <div className="sololearn-summary-card-design">
            <div className="sololearn-summary-row">
              <span>Abonament</span>
              <span><b>{planText}</b></span>
            </div>
            
           
        
            
            <div className="sololearn-summary-row">
              <span>Frecventa de facturare</span>
              <span><b>{selectedPlan === 'anual' ? '1 an' : '1 luna'}</b></span>
            </div>
            <div className="sololearn-summary-row">
              <span>Urmatoarea facturare</span>
              <span><b>{new Date(Date.now() + 14*24*60*60*1000).toLocaleDateString('ro-RO')}</b></span>
            </div>
            
            <div className="sololearn-summary-total">
              <span style={{ color: '#000000ff', fontWeight: 700, fontSize: 25 }}>Total de plata</span>
              <span style={{ color: '#000000ff', fontWeight: 700, fontSize: 25 }}>{selectedPlan === 'anual' ? '550 lei' : '70 lei'}</span>
            </div>
          </div>
          {/* Payment button and info: visible here only on desktop */}
          <div className="sololearn-pay-desktop-bar">
            <button
              className="sololearn-pay-btn"
              style={{ width: '100%', margin: '24px 0 8px 0', fontSize: 20 }}
              disabled={processing || !stripe}
              onClick={handleSubmit}
            >
              {processing ? 'Se proceseaza...' : 'Platesc in siguranta'}
            </button>
            <div className="sololearn-secure-row" style={{ justifyContent: 'center', marginBottom: 8 }}>
              <span className="sololearn-secure-badge">🔒 Plati securizate garantat</span>
            </div>
            <div className="sololearn-powered" style={{ textAlign: 'center', color: '#b0b0b0', fontSize: 14 }}>
              Procesat prin Stripe
            </div>
            <div className="sololearn-summary-note">
              Vei fi taxat automat la finalul perioadei de proba.<br />
              Poti anula oricand inainte din Setari.
            </div>
          </div>
        {/* Fixed bottom bar for mobile */}
      
        </div>
      </div>
    </div>

  );
};

export default StripePaymentForm;
